// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/system.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { MetricType } from "./metrics_pb.js";
import { Command } from "./command_pb.js";

/**
 * @generated from enum wavin.aqora.v2.SystemAutomation
 */
export const SystemAutomation = proto3.makeEnum(
  "wavin.aqora.v2.SystemAutomation",
  [
    {no: 0, name: "SYSTEM_AUTOMATION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SYSTEM_AUTOMATION_ON", localName: "ON"},
    {no: 2, name: "SYSTEM_AUTOMATION_OFF", localName: "OFF"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.SystemProductionState
 */
export const SystemProductionState = proto3.makeEnum(
  "wavin.aqora.v2.SystemProductionState",
  [
    {no: 0, name: "SYSTEM_PRODUCTION_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SYSTEM_PRODUCTION_STATE_CONFIGURATION", localName: "CONFIGURATION"},
    {no: 2, name: "SYSTEM_PRODUCTION_STATE_READY_FOR_INSTALL", localName: "READY_FOR_INSTALL"},
    {no: 4, name: "SYSTEM_PRODUCTION_STATE_PRODUCTION", localName: "PRODUCTION"},
    {no: 5, name: "SYSTEM_PRODUCTION_STATE_OUT_OF_PRODUCTION", localName: "OUT_OF_PRODUCTION"},
    {no: 6, name: "SYSTEM_PRODUCTION_STATE_PRODUCTION_EDIT", localName: "PRODUCTION_EDIT"},
    {no: 7, name: "SYSTEM_PRODUCTION_STATE_ADVICE", localName: "ADVICE"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.PeripheralType
 */
export const PeripheralType = proto3.makeEnum(
  "wavin.aqora.v2.PeripheralType",
  [
    {no: 0, name: "PERIPHERAL_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PERIPHERAL_TYPE_RAIN_SENSOR", localName: "RAIN_SENSOR"},
    {no: 2, name: "PERIPHERAL_TYPE_WATER_HEIGHT_SENSOR", localName: "WATER_HEIGHT_SENSOR"},
    {no: 3, name: "PERIPHERAL_TYPE_TEMPERATURE_SENSOR", localName: "TEMPERATURE_SENSOR"},
    {no: 4, name: "PERIPHERAL_TYPE_VALVE_ACTUATOR", localName: "VALVE_ACTUATOR"},
    {no: 5, name: "PERIPHERAL_TYPE_TAP_ACTUATOR", localName: "TAP_ACTUATOR"},
    {no: 6, name: "PERIPHERAL_TYPE_PUMP_ACTUATOR", localName: "PUMP_ACTUATOR"},
    {no: 7, name: "PERIPHERAL_TYPE_FLOW_SENSOR", localName: "FLOW_SENSOR"},
    {no: 8, name: "PERIPHERAL_TYPE_HUMIDITY_SENSOR", localName: "HUMIDITY_SENSOR"},
    {no: 9, name: "PERIPHERAL_TYPE_WIND_SENSOR", localName: "WIND_SENSOR"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.ProductType
 */
export const ProductType = proto3.makeEnum(
  "wavin.aqora.v2.ProductType",
  [
    {no: 0, name: "PRODUCT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRODUCT_TYPE_TAP", localName: "TAP"},
    {no: 2, name: "PRODUCT_TYPE_RAIN_METER", localName: "RAIN_METER"},
    {no: 3, name: "PRODUCT_TYPE_SMART_DROP", localName: "SMART_DROP"},
    {no: 4, name: "PRODUCT_TYPE_SMART_LEVEL", localName: "SMART_LEVEL"},
    {no: 5, name: "PRODUCT_TYPE_PUMP", localName: "PUMP"},
    {no: 6, name: "PRODUCT_TYPE_VALVE", localName: "VALVE"},
    {no: 7, name: "PRODUCT_TYPE_CONTROLLER", localName: "CONTROLLER"},
    {no: 8, name: "PRODUCT_TYPE_LEVEL", localName: "LEVEL"},
  ],
);

/**
 * model specific type so be knows what kind of device config is related to it.
 *
 * @generated from enum wavin.aqora.v2.CreateProductType
 */
export const CreateProductType = proto3.makeEnum(
  "wavin.aqora.v2.CreateProductType",
  [
    {no: 0, name: "CREATE_PRODUCT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CREATE_PRODUCT_TYPE_TAP", localName: "TAP"},
    {no: 2, name: "CREATE_PRODUCT_TYPE_RAIN_METER", localName: "RAIN_METER"},
    {no: 5, name: "CREATE_PRODUCT_TYPE_POLDER_VALVE", localName: "POLDER_VALVE"},
    {no: 6, name: "CREATE_PRODUCT_TYPE_STAAL_RADAR_LEVEL", localName: "STAAL_RADAR_LEVEL"},
    {no: 7, name: "CREATE_PRODUCT_TYPE_POND_PLC", localName: "POND_PLC"},
    {no: 8, name: "CREATE_PRODUCT_TYPE_PUMP", localName: "PUMP"},
    {no: 9, name: "CREATE_PRODUCT_TYPE_VALVE", localName: "VALVE"},
    {no: 10, name: "CREATE_PRODUCT_TYPE_LEVEL_SENSOR", localName: "LEVEL_SENSOR"},
    {no: 11, name: "CREATE_PRODUCT_TYPE_CONTROLLER", localName: "CONTROLLER"},
    {no: 12, name: "CREATE_PRODUCT_TYPE_RAIN_METER_WUNDERGROUND", localName: "RAIN_METER_WUNDERGROUND"},
  ],
);

/**
 * A system is the container for devices and topology
 *
 * @generated from message wavin.aqora.v2.System
 */
export const System = proto3.makeMessageType(
  "wavin.aqora.v2.System",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "create_time", kind: "message", T: Timestamp },
    { no: 3, name: "update_time", kind: "message", T: Timestamp },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "project", kind: "message", T: System_Project },
    { no: 6, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "latitude_dd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "longitude_dd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "automation", kind: "enum", T: proto3.getEnumType(SystemAutomation) },
    { no: 11, name: "production_state", kind: "enum", T: proto3.getEnumType(SystemProductionState) },
    { no: 12, name: "devices", kind: "message", T: Device, repeated: true },
    { no: 13, name: "topologies", kind: "message", T: Topology, repeated: true },
    { no: 14, name: "crm_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "growing_months", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 18, name: "service_contract_end_date", kind: "message", T: Timestamp },
    { no: 19, name: "min_temperature", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
      {no: 20, name: "silent_hours", kind: "message", T: SilentHours},
      {no: 21, name: "operation_mode", kind: "enum", T: proto3.getEnumType(System_OperationMode)},
      {no: 22, name: "config_options", kind: "message", T: System_ConfigOptions},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.System.OperationMode
 */
export const System_OperationMode = proto3.makeEnum(
  "wavin.aqora.v2.System.OperationMode",
  [
    {no: 0, name: "OPERATION_MODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "OPERATION_MODE_MANUAL", localName: "MANUAL"},
    {no: 2, name: "OPERATION_MODE_AUTO", localName: "AUTO"},
    {no: 3, name: "OPERATION_MODE_AUTO_OUTSIDE_GROWING", localName: "AUTO_OUTSIDE_GROWING"},
    {no: 4, name: "OPERATION_MODE_AUTO_GROWING", localName: "AUTO_GROWING"},
    {no: 5, name: "OPERATION_MODE_AUTO_FREEZING_PROTECTION", localName: "AUTO_FREEZING_PROTECTION"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.System.Project
 */
export const System_Project = proto3.makeMessageType(
  "wavin.aqora.v2.System.Project",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "System_Project"},
);

/**
 * @generated from message wavin.aqora.v2.System.ConfigOptions
 */
export const System_ConfigOptions = proto3.makeMessageType(
  "wavin.aqora.v2.System.ConfigOptions",
  () => [
      {
          no: 1,
          name: "allowed_create_product_types",
          kind: "enum",
          T: proto3.getEnumType(CreateProductType),
          repeated: true
      },
  ],
  {localName: "System_ConfigOptions"},
);

/**
 * @generated from message wavin.aqora.v2.SilentHours
 */
export const SilentHours = proto3.makeMessageType(
  "wavin.aqora.v2.SilentHours",
  () => [
      {no: 1, name: "start", kind: "scalar", T: 13 /* ScalarType.UINT32 */},
      {no: 2, name: "stop", kind: "scalar", T: 13 /* ScalarType.UINT32 */},
  ],
);

/**
 * The physical device that has the Particle board
 *
 * @generated from message wavin.aqora.v2.Device
 */
export const Device = proto3.makeMessageType(
  "wavin.aqora.v2.Device",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(Device_Type) },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "peripherals", kind: "message", T: Peripheral, repeated: true },
    { no: 8, name: "available_metric_types", kind: "enum", T: proto3.getEnumType(MetricType), repeated: true },
    { no: 9, name: "commissioning_state", kind: "enum", T: proto3.getEnumType(Device_CommissioningState) },
    { no: 10, name: "mode", kind: "enum", T: proto3.getEnumType(Device_Mode) },
    { no: 11, name: "available_commands", kind: "message", T: Command, repeated: true },
      {no: 12, name: "ota_state", kind: "enum", T: proto3.getEnumType(Device_OTAState)},
      {no: 21, name: "allowed_product_types_linked", kind: "enum", T: proto3.getEnumType(ProductType), repeated: true},
      {no: 22, name: "model", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Device.Type
 */
export const Device_Type = proto3.makeEnum(
  "wavin.aqora.v2.Device.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_DROP_1", localName: "DROP_1"},
    {no: 2, name: "TYPE_DROP_2", localName: "DROP_2"},
    {no: 3, name: "TYPE_MILL", localName: "MILL"},
    {no: 4, name: "TYPE_LEVEL", localName: "LEVEL"},
    {no: 5, name: "TYPE_POND_PLC", localName: "POND_PLC"},
    {no: 6, name: "TYPE_STAAL_RADAR_LEVEL", localName: "STAAL_RADAR_LEVEL"},
    {no: 7, name: "TYPE_API", localName: "API"},
    {no: 8, name: "TYPE_GENERAL_CONTROLLER", localName: "GENERAL_CONTROLLER"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Device.CommissioningState
 */
export const Device_CommissioningState = proto3.makeEnum(
  "wavin.aqora.v2.Device.CommissioningState",
  [
    {no: 0, name: "COMMISSIONING_STATE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMISSIONING_STATE_READY_FOR_LINKING", localName: "READY_FOR_LINKING"},
    {no: 2, name: "COMMISSIONING_STATE_PENDING_CLOUD_CONNECTION", localName: "PENDING_CLOUD_CONNECTION"},
    {no: 3, name: "COMMISSIONING_STATE_READY_FOR_TESTING", localName: "READY_FOR_TESTING"},
    {no: 4, name: "COMMISSIONING_STATE_OPERATIONAL", localName: "OPERATIONAL"},
    {no: 5, name: "COMMISSIONING_STATE_PERIPHERAL_LINKING", localName: "PERIPHERAL_LINKING"},
    {no: 6, name: "COMMISSIONING_STATE_NEEDS_CONFIGURATION", localName: "NEEDS_CONFIGURATION"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Device.Mode
 */
export const Device_Mode = proto3.makeEnum(
  "wavin.aqora.v2.Device.Mode",
  [
    {no: 0, name: "MODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MODE_OPERATIONAL", localName: "OPERATIONAL"},
    {no: 2, name: "MODE_MAINTENANCE", localName: "MAINTENANCE"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Device.OTAState
 */
export const Device_OTAState = proto3.makeEnum(
  "wavin.aqora.v2.Device.OTAState",
  [
    {no: 0, name: "OTA_STATE_UNSPECIFIED"},
    {no: 1, name: "OTA_STATE_IDLE"},
    {no: 2, name: "OTA_STATE_PENDING"},
    {no: 3, name: "OTA_STATE_UPDATING"},
  ],
);

/**
 * Peripheral is an actuator or sensor connected to a physical device
 *
 * @generated from message wavin.aqora.v2.Peripheral
 */
export const Peripheral = proto3.makeMessageType(
  "wavin.aqora.v2.Peripheral",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      {no: 2, name: "type", kind: "enum", T: proto3.getEnumType(PeripheralType)},
    { no: 3, name: "available_metric_types", kind: "enum", T: proto3.getEnumType(MetricType), repeated: true },
    { no: 4, name: "available_commands", kind: "message", T: Command, repeated: true },
      {no: 5, name: "attributes", kind: "message", T: PeripheralAttributes},
  ],
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes
 */
export const PeripheralAttributes = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes",
  () => [
      {no: 10, name: "valve_actuator", kind: "message", T: PeripheralAttributes_ValveActuator, oneof: "attributes"},
      {
          no: 11,
          name: "water_height_sensor",
          kind: "message",
          T: PeripheralAttributes_WaterHeightSensor,
          oneof: "attributes"
      },
      {no: 12, name: "tap_actuator", kind: "message", T: PeripheralAttributes_TapActuator, oneof: "attributes"},
      {
          no: 13,
          name: "temperature_sensor",
          kind: "message",
          T: PeripheralAttributes_TemperatureSensor,
          oneof: "attributes"
      },
      {no: 14, name: "rain_sensor", kind: "message", T: PeripheralAttributes_RainSensor, oneof: "attributes"},
      {no: 15, name: "pump_actuator", kind: "message", T: PeripheralAttributes_PumpActuator, oneof: "attributes"},
      {no: 16, name: "flow_sensor", kind: "message", T: PeripheralAttributes_FlowSensor, oneof: "attributes"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.PeripheralAttributes.Editable
 */
export const PeripheralAttributes_Editable = proto3.makeEnum(
  "wavin.aqora.v2.PeripheralAttributes.Editable",
  [
    {no: 0, name: "EDITABLE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EDITABLE_FALSE", localName: "FALSE"},
    {no: 2, name: "EDITABLE_TRUE", localName: "TRUE"},
    {no: 3, name: "EDITABLE_VIEW_ONLY", localName: "VIEW_ONLY"},
    {no: 4, name: "EDITABLE_TRUE_COMMISSIONING", localName: "TRUE_COMMISSIONING"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes.ValveActuator
 */
export const PeripheralAttributes_ValveActuator = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes.ValveActuator",
  () => [
      {no: 1, name: "valve_size", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 2, name: "valve_size_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
  ],
  {localName: "PeripheralAttributes_ValveActuator"},
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes.WaterHeightSensor
 */
export const PeripheralAttributes_WaterHeightSensor = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes.WaterHeightSensor",
  () => [
      {no: 1, name: "sensor_offset", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 2, name: "sensor_offset_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
      {no: 3, name: "sensor_range", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 4, name: "sensor_range_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
      {no: 5, name: "polder_level", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 6, name: "polder_level_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
  ],
  {localName: "PeripheralAttributes_WaterHeightSensor"},
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes.TapActuator
 */
export const PeripheralAttributes_TapActuator = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes.TapActuator",
  () => [
      {no: 1, name: "flow_rate", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 2, name: "flow_rate_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
  ],
  {localName: "PeripheralAttributes_TapActuator"},
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes.RainSensor
 */
export const PeripheralAttributes_RainSensor = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes.RainSensor",
  () => [
      {no: 1, name: "bucket_size", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 2, name: "bucket_size_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
  ],
  {localName: "PeripheralAttributes_RainSensor"},
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes.TemperatureSensor
 */
export const PeripheralAttributes_TemperatureSensor = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes.TemperatureSensor",
  () => [
      {no: 1, name: "bus_address", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true},
      {no: 2, name: "bus_address_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
  ],
  {localName: "PeripheralAttributes_TemperatureSensor"},
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes.PumpActuator
 */
export const PeripheralAttributes_PumpActuator = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes.PumpActuator",
  () => [
      {no: 1, name: "max_flow_rate", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 11, name: "max_flow_rate_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
      {no: 2, name: "min_flow_rate", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 12, name: "min_flow_rate_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
      {no: 3, name: "control_type", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_PumpActuator_ControlType)},
      {no: 13, name: "control_type_editable", kind: "enum", T: proto3.getEnumType(PeripheralAttributes_Editable)},
  ],
  {localName: "PeripheralAttributes_PumpActuator"},
);

/**
 * @generated from enum wavin.aqora.v2.PeripheralAttributes.PumpActuator.ControlType
 */
export const PeripheralAttributes_PumpActuator_ControlType = proto3.makeEnum(
  "wavin.aqora.v2.PeripheralAttributes.PumpActuator.ControlType",
  [
    {no: 0, name: "CONTROL_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONTROL_TYPE_FLOW", localName: "FLOW"},
    {no: 2, name: "CONTROL_TYPE_PERCENTAGE", localName: "PERCENTAGE"},
    {no: 3, name: "CONTROL_TYPE_ON_OFF", localName: "ON_OFF"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.PeripheralAttributes.FlowSensor
 */
export const PeripheralAttributes_FlowSensor = proto3.makeMessageType(
  "wavin.aqora.v2.PeripheralAttributes.FlowSensor",
  [],
  {localName: "PeripheralAttributes_FlowSensor"},
);

/**
 * The topology of the system represents the physical location of reservoirs, drains and products and the relation between those.
 *
 * @generated from message wavin.aqora.v2.Topology
 */
export const Topology = proto3.makeMessageType(
  "wavin.aqora.v2.Topology",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "reservoirs", kind: "message", T: Reservoir, repeated: true },
    { no: 3, name: "drains", kind: "message", T: Drain, repeated: true },
    { no: 4, name: "products", kind: "message", T: Product, repeated: true },
  ],
);

/**
 * The reservoir stores the water
 *
 * @generated from message wavin.aqora.v2.Reservoir
 */
export const Reservoir = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      {no: 6, name: "area_m2", kind: "scalar", T: 3 /* ScalarType.INT64 */},
    { no: 7, name: "min_water_height_mm", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
      {no: 17, name: "min_water_capacity_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
    { no: 8, name: "max_water_height_mm", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
      {no: 18, name: "max_water_capacity_l", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 10, name: "target_water_height_growing_months", kind: "scalar", T: 5 /* ScalarType.INT32 */},
      {no: 13, name: "target_capacity_percentage_growing_months", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 11, name: "target_water_height", kind: "scalar", T: 5 /* ScalarType.INT32 */},
      {no: 14, name: "target_capacity_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 12, name: "factor_hollow", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 20, name: "blue_roof", kind: "message", T: Reservoir_BlueRoof, oneof: "type_properties"},
      {no: 21, name: "green_roof", kind: "message", T: Reservoir_GreenRoof, oneof: "type_properties"},
      {no: 22, name: "tank", kind: "message", T: Reservoir_Tank, oneof: "type_properties"},
      {no: 23, name: "sewer", kind: "message", T: Reservoir_Sewer, oneof: "type_properties"},
      {no: 24, name: "infiltration_tank", kind: "message", T: Reservoir_InfiltrationTank, oneof: "type_properties"},
      {no: 25, name: "pond", kind: "message", T: Reservoir_Pond, oneof: "type_properties"},
      {no: 26, name: "wadi", kind: "message", T: Reservoir_Wadi, oneof: "type_properties"},
      {no: 27, name: "conventional_roof", kind: "message", T: Reservoir_ConventionalRoof, oneof: "type_properties"},
      {no: 30, name: "ui_position", kind: "message", T: Reservoir_UIPosition},
      {no: 31, name: "config_options", kind: "message", T: Reservoir_ConfigOptions},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Reservoir.CrateType
 */
export const Reservoir_CrateType = proto3.makeEnum(
  "wavin.aqora.v2.Reservoir.CrateType",
  [
    {no: 0, name: "CRATE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CRATE_TYPE_WAVIN_AQUACELL_UP_85", localName: "WAVIN_AQUACELL_UP_85"},
    {no: 2, name: "CRATE_TYPE_WAVIN_AQUACELL_UP_85_CAPILLARITY", localName: "WAVIN_AQUACELL_UP_85_CAPILLARITY"},
    {no: 3, name: "CRATE_TYPE_WAVIN_AQUACELL_UP_160", localName: "WAVIN_AQUACELL_UP_160"},
    {no: 4, name: "CRATE_TYPE_WAVIN_AQUACELL_UP_160_CAPILLARITY", localName: "WAVIN_AQUACELL_UP_160_CAPILLARITY"},
    {no: 5, name: "CRATE_TYPE_OTHER", localName: "OTHER"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Reservoir.GreenType
 */
export const Reservoir_GreenType = proto3.makeEnum(
  "wavin.aqora.v2.Reservoir.GreenType",
  [
    {no: 0, name: "GREEN_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GREEN_TYPE_DROUGHT_PROOF", localName: "DROUGHT_PROOF"},
    {no: 2, name: "GREEN_TYPE_SEDUM", localName: "SEDUM"},
    {no: 3, name: "GREEN_TYPE_BIODIVERSE_SEDUM", localName: "BIODIVERSE_SEDUM"},
    {no: 4, name: "GREEN_TYPE_SEED_MIX", localName: "SEED_MIX"},
    {no: 5, name: "GREEN_TYPE_GRASSES", localName: "GRASSES"},
    {no: 6, name: "GREEN_TYPE_FULL_GARDEN", localName: "FULL_GARDEN"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Reservoir.DryProtection
 */
export const Reservoir_DryProtection = proto3.makeEnum(
  "wavin.aqora.v2.Reservoir.DryProtection",
  [
    {no: 0, name: "DRY_PROTECTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DRY_PROTECTION_DISABLED", localName: "DISABLED"},
    {no: 2, name: "DRY_PROTECTION_GROWING", localName: "GROWING"},
    {no: 3, name: "DRY_PROTECTION_OUTSIDE_GROWING", localName: "OUTSIDE_GROWING"},
    {no: 4, name: "DRY_PROTECTION_ALWAYS", localName: "ALWAYS"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.ConventionalRoof
 */
export const Reservoir_ConventionalRoof = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.ConventionalRoof",
  [],
  {localName: "Reservoir_ConventionalRoof"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.BlueRoof
 */
export const Reservoir_BlueRoof = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.BlueRoof",
  () => [
      {no: 1, name: "crate_type", kind: "enum", T: proto3.getEnumType(Reservoir_CrateType)},
  ],
  {localName: "Reservoir_BlueRoof"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.GreenRoof
 */
export const Reservoir_GreenRoof = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.GreenRoof",
  () => [
      {no: 1, name: "area_green", kind: "scalar", T: 5 /* ScalarType.INT32 */},
      {no: 2, name: "green_type", kind: "enum", T: proto3.getEnumType(Reservoir_GreenType)},
      {no: 3, name: "crate_type", kind: "enum", T: proto3.getEnumType(Reservoir_CrateType)},
  ],
  {localName: "Reservoir_GreenRoof"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.Tank
 */
export const Reservoir_Tank = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.Tank",
  () => [
      {no: 1, name: "dry_protection", kind: "enum", T: proto3.getEnumType(Reservoir_DryProtection)},
      {no: 2, name: "external_usage", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 3, name: "capture_area", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "Reservoir_Tank"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.Sewer
 */
export const Reservoir_Sewer = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.Sewer",
  () => [
      {no: 1, name: "limitations", kind: "enum", T: proto3.getEnumType(Reservoir_Sewer_Limitations)},
  ],
  {localName: "Reservoir_Sewer"},
);

/**
 * @generated from enum wavin.aqora.v2.Reservoir.Sewer.Limitations
 */
export const Reservoir_Sewer_Limitations = proto3.makeEnum(
  "wavin.aqora.v2.Reservoir.Sewer.Limitations",
  [
    {no: 0, name: "LIMITATIONS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LIMITATIONS_NONE", localName: "NONE"},
    {no: 2, name: "LIMITATIONS_NOT_DURING_NIGHTTIME", localName: "NOT_DURING_NIGHTTIME"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.InfiltrationTank
 */
export const Reservoir_InfiltrationTank = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.InfiltrationTank",
  () => [
      {no: 2, name: "drainage_speed", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "Reservoir_InfiltrationTank"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.Pond
 */
export const Reservoir_Pond = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.Pond",
  () => [
      {no: 1, name: "nap_offset", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "Reservoir_Pond"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.Wadi
 */
export const Reservoir_Wadi = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.Wadi",
  () => [
      {no: 1, name: "max_volume", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 2, name: "drainage_speed", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
  ],
  {localName: "Reservoir_Wadi"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.UIPosition
 */
export const Reservoir_UIPosition = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.UIPosition",
  () => [
      {no: 1, name: "x", kind: "scalar", T: 5 /* ScalarType.INT32 */},
      {no: 2, name: "y", kind: "scalar", T: 5 /* ScalarType.INT32 */},
  ],
  {localName: "Reservoir_UIPosition"},
);

/**
 * @generated from message wavin.aqora.v2.Reservoir.ConfigOptions
 */
export const Reservoir_ConfigOptions = proto3.makeMessageType(
  "wavin.aqora.v2.Reservoir.ConfigOptions",
  () => [
      {no: 1, name: "allow_pressure_pipe", kind: "scalar", T: 8 /* ScalarType.BOOL */},
      {no: 2, name: "allow_gravitational_drain", kind: "scalar", T: 8 /* ScalarType.BOOL */},
      {
          no: 3,
          name: "allowed_create_product_types",
          kind: "enum",
          T: proto3.getEnumType(CreateProductType),
          repeated: true
      },
  ],
  {localName: "Reservoir_ConfigOptions"},
);

/**
 * Drain is the pipe connecting reservoirs and/or sewers
 *
 * @generated from message wavin.aqora.v2.Drain
 */
export const Drain = proto3.makeMessageType(
  "wavin.aqora.v2.Drain",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_reservoir_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to_reservoir_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      {no: 4, name: "overflow_height", kind: "scalar", T: 2 /* ScalarType.FLOAT */},
      {no: 5, name: "flow_restriction_speed", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true},
      {no: 7, name: "pressure_pipe", kind: "scalar", T: 8 /* ScalarType.BOOL */},
      {no: 8, name: "drainage_system", kind: "enum", T: proto3.getEnumType(Drain_DrainageSystem)},
      {no: 9, name: "location", kind: "enum", T: proto3.getEnumType(Drain_Location)},
      {no: 10, name: "passive_drain_count", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true},
      {no: 11, name: "config_options", kind: "message", T: Drain_ConfigOptions},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Drain.DrainageSystem
 */
export const Drain_DrainageSystem = proto3.makeEnum(
  "wavin.aqora.v2.Drain.DrainageSystem",
  [
    {no: 0, name: "DRAINAGE_SYSTEM_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DRAINAGE_SYSTEM_GRAVITATIONAL", localName: "GRAVITATIONAL"},
    {no: 2, name: "DRAINAGE_SYSTEM_SIPHONIC_QUICKSTREAM", localName: "SIPHONIC_QUICKSTREAM"},
    {no: 3, name: "DRAINAGE_SYSTEM_SIPHONIC_UNIVERSAL", localName: "SIPHONIC_UNIVERSAL"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Drain.Location
 */
export const Drain_Location = proto3.makeEnum(
  "wavin.aqora.v2.Drain.Location",
  [
    {no: 0, name: "LOCATION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LOCATION_MID_DRAIN", localName: "MID_DRAIN"},
    {no: 2, name: "LOCATION_SIDE_DRAIN", localName: "SIDE_DRAIN"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.Drain.ConfigOptions
 */
export const Drain_ConfigOptions = proto3.makeMessageType(
  "wavin.aqora.v2.Drain.ConfigOptions",
  () => [
      {
          no: 1,
          name: "allowed_create_product_types",
          kind: "enum",
          T: proto3.getEnumType(CreateProductType),
          repeated: true
      },
      {no: 2, name: "allow_passive_drain_count_set", kind: "scalar", T: 8 /* ScalarType.BOOL */},
      {
          no: 3,
          name: "allowed_drainage_systems",
          kind: "enum",
          T: proto3.getEnumType(Drain_DrainageSystem),
          repeated: true
      },
  ],
  {localName: "Drain_ConfigOptions"},
);

/**
 * Product represents the physical object in the topology to group peripherals and the location within the topology
 *
 * @generated from message wavin.aqora.v2.Product
 */
export const Product = proto3.makeMessageType(
  "wavin.aqora.v2.Product",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      {no: 2, name: "type", kind: "enum", T: proto3.getEnumType(ProductType)},
    { no: 3, name: "peripheral_resource_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "position", kind: "message", T: Product_Position },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      {no: 6, name: "needs_peripheral_linking", kind: "scalar", T: 8 /* ScalarType.BOOL */},
      {no: 7, name: "main_device_resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */},
  ],
);

/**
 * Position is the physical position of the product
 *
 * @generated from message wavin.aqora.v2.Product.Position
 */
export const Product_Position = proto3.makeMessageType(
  "wavin.aqora.v2.Product.Position",
  () => [
    { no: 1, name: "reservoir_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "drain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Product_Position"},
);

